module.exports = __webpack_public_path__ + "img/image2.4a52216f.jpg";